import { render, staticRenderFns } from "./imageItem.vue?vue&type=template&id=4d8db707&scoped=true&"
import script from "./imageItem.vue?vue&type=script&lang=js&"
export * from "./imageItem.vue?vue&type=script&lang=js&"
import style0 from "./imageItem.vue?vue&type=style&index=0&id=4d8db707&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8db707",
  null
  
)

export default component.exports